import Dashboard from './Dashboard';

export { Dashboard };



// WEBPACK FOOTER //
// ./src/modules/screens/dashboard/Dashboard/components/index.js